<template>
    <div :id="data.id" class="flex flex-col gap-2 w-full">
        <img :src="data.icon" class="item__icon" />
        <Teleport to="body">
            <dx-tooltip
                :target="`#${data.id}`"
                show-event="mouseenter"
                hide-event="mouseleave"
                :hide-on-outside-click="false"
                position="left"
            >
                {{ data.name }}
            </dx-tooltip>
        </Teleport>
    </div>
</template>

<script setup>
import { DxTooltip } from 'devextreme-vue';

defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});
</script>

<style lang="scss" scoped>
.item__icon {
    min-width: 36px;
    min-height: 36px;
}
</style>
